import styled from 'styled-components'

const StyledReferralTrack = styled.div``

export default StyledReferralTrack
